<template>
  <div class="circuitMod" @click="clickFn">
    <div class="circuitModcontent">
      <div class="city">
        <span class="startCity cityItem">
          <h3>{{circuitData.startCity.name}}</h3>
          <p>{{circuitData.startCity.add}}</p>
        </span>
        <span class="endCity cityItem">
           <h3>{{circuitData.endCity.name}}</h3>
          <p>{{circuitData.endCity.add}}</p>
        </span>
        <span class="inverse">
          <i class="iconfont icon-zhuanhuan1"></i>
        </span>
      </div>
      <div class="charges">
        <span class="chargesItem">
          <h2>{{circuitData.carpool.name}}</h2>
          <p><span class="sum">{{circuitData.carpool.sum}}</span>元/人</p>
        </span>
        <span class="chargesItem">
          <h2>{{circuitData.chartered.name}}</h2>
          <p><span class="sum">{{circuitData.chartered.sum}}</span>元/辆</p>
        </span>
        <span class="chargesItem">
          <h2>{{circuitData.sendGoods.name}}</h2>
          <p><span class="sum">{{circuitData.sendGoods.sum}}</span>元/件</p>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'xk-circuitMod',
    props: ['data'],
    data () {
      return {
        circuitData: this.data
      }
    },
    methods: {
      clickFn: function () {
        this.$emit('click')
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .circuitMod {
    width: 100%;
    background-color: #fff;
    border-radius: 0.333rem;
    overflow: hidden;
    margin-bottom: 1rem;
    .circuitModcontent {
      text-align: center;
      width: 100%;
      .city {
        box-sizing: border-box;
        padding: 1rem;
        border-bottom: 1px solid #eee;
        width: 100%;
        position: relative;
        .cityItem {
          width: 48%;
          h3 {
            color: #333;
            font-size: 1.6rem;
            margin-bottom: 0.1rem;
          }
          P {
            color: #999999;
            font-size: 1rem;
          }
        }
        .inverse {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          i {
            font-size: 1.6rem;
            color: #666666;
          }
        }
      }
      .charges {
        box-sizing: border-box;
        width: 100%;
        padding: 1.8rem 1rem;
        .chargesItem {
          width: 32%;
          h2 {
            font-size: 1.2rem;
            margin-bottom: 0.2rem;
            color: #666666;
          }
          P {
            font-size: 0.833rem;
            color: #999999;
            .sum {
              font-size: 1.3rem;
              color: #f06553;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// circuitMod.vue?5e36dfc4